import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  sendJSON,
  setMethod,
  setServiceUrl,
} from '@library/http/requests'

export type EligibleDiscountType = 'percentageOffOrder' | 'amountOffOrder'

// `amount` is a string: "20" for a percentage, "15" for £.
export type EligibleDiscount = {
  type: EligibleDiscountType
  amount: string
  expiry_date: string | null
  reason: {
    conditions: string[]
    promo_code: string | null
  }
}

export type EligibilityRequest = {
  delivery_date: string
  box_type?: 'subscription' | 'transactional'
}

export type EligibilityResponse = {
  data: {
    eligible: EligibleDiscount[]
  }
  meta: Record<string, never>
}

const eligibilityParser = async (response: Response): Promise<EligibilityResponse> => {
  if (!response.ok) {
    const body = await response.text()
    throw new Error(`promotions service responded with ${response.status}: ${body}`)
  }

  return (await response.json()) as EligibilityResponse
}

const eligibilityRequest = composeRequest<EligibilityRequest>(
  setServiceUrl('promotions', 1),
  addPath('eligibility'),
  setMethod('POST'),
  sendJSON(),
  goustoHeaders,
)

export const eligibilityFetcher = composeFetch(eligibilityRequest, eligibilityParser)
